/* eslint-disable jsx-a11y/scope */
import React, { useState, useEffect } from "react";
const ES27RevisedUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),

        TotalAllCategoriesM3: 0,
        TotalAllCategoriesF4: 0,
        TotalAllCategoriesT5: 0,
        Scm6: 0,
        Scf7: 0,
        Sct8: 0,
        Stm9: 0,
        Stf10: 0,
        Stt11: 0,
        Obcm12: 0,
        Obcf13: 0,
        Obct14: 0,
        Phm15: 0,
        Phf16: 0,
        Pht17: 0,
        MinorityCommunityM18: 0,
        MinorityCommunityF19: 0,
        MinorityCommunityT20: 0,

    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetEs27revisedDetails', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    //console.log(maindata)
                    setFormData({
                        TotalAllCategoriesM3: maindata.totalAllCategoriesM3,
                        TotalAllCategoriesF4: maindata.totalAllCategoriesF4,
                        TotalAllCategoriesT5: maindata.totalAllCategoriesT5,
                        Scm6: maindata.scm6,
                        Scf7: maindata.scf7,
                        Sct8: maindata.sct8,
                        Stm9: maindata.stm9,
                        Stf10: maindata.stf10,
                        Stt11: maindata.stt11,
                        Obcm12: maindata.obcm12,
                        Obcf13: maindata.obcf13,
                        Obct14: maindata.obct14,
                        Phm15: maindata.phm15,
                        Phf16: maindata.phf16,
                        Pht17: maindata.pht17,
                        MinorityCommunityM18: maindata.minorityCommunityM18,
                        MinorityCommunityF19: maindata.minorityCommunityF19,
                        MinorityCommunityT20: maindata.minorityCommunityT20,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsEs27revised', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    setFormData({
                        TotalAllCategoriesM3: maindata.totalAllCategoriesM3,
                        TotalAllCategoriesF4: maindata.totalAllCategoriesF4,
                        TotalAllCategoriesT5: maindata.totalAllCategoriesT5,
                        Scm6: maindata.scm6,
                        Scf7: maindata.scf7,
                        Sct8: maindata.sct8,
                        Stm9: maindata.stm9,
                        Stf10: maindata.stf10,
                        Stt11: maindata.stt11,
                        Obcm12: maindata.obcm12,
                        Obcf13: maindata.obcf13,
                        Obct14: maindata.obct14,
                        Phm15: maindata.phm15,
                        Phf16: maindata.phf16,
                        Pht17: maindata.pht17,
                        MinorityCommunityM18: maindata.minorityCommunityM18,
                        MinorityCommunityF19: maindata.minorityCommunityF19,
                        MinorityCommunityT20: maindata.minorityCommunityT20,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })
        props.setGTotal(props.GTotal + 1)
    };






    useEffect(() => {
        getdata()

    }, [props.Change])

    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };


    return (
        load ? null :
            <tr scope="row"  >
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.sno}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >
                    {props.name}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        id="TotalAllCategoriesM3"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="TotalAllCategoriesM3"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.TotalAllCategoriesM3}
                    /> : formData.TotalAllCategoriesM3}
                </td>
                {/*  <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    <label>{formData.TotalAllCategoriesM3} </label>
                </td>*/}
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        id="TotalAllCategoriesF4"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="TotalAllCategoriesF4"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.TotalAllCategoriesF4}
                    /> : formData.TotalAllCategoriesF4}
                </td>
                {/*<td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    <label>{formData.TotalAllCategoriesF4} </label>
                </td>*/}
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        id="TotalAllCategoriesT5"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="TotalAllCategoriesT5"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.TotalAllCategoriesT5}
                    /> : formData.TotalAllCategoriesT5}
                </td>
                {/*<td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    <label>{formData.TotalAllCategoriesT5} </label>
                </td>*/}
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 80 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Scm6"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Scm6"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Scm6}
                    /> : formData.Scm6}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Scf7"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Scf7"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()} defaultValue={formData.Scf7}
                    /> : formData.Scf7}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Sct8"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Sct8"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Sct8}
                    /> : formData.Sct8}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Stm9"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Stm9"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Stm9}
                    /> : formData.Stm9}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Stf10"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Stf10"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Stf10}
                    /> : formData.Stf10}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Stt11"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Stt11"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Stt11}
                    /> : formData.Stt11}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obcm12"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Obcm12"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obcm12}
                    /> : formData.Obcm12}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obcf13"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Obcf13"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obcf13}
                    /> : formData.Obcf13}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Obct14"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Obct14"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Obct14}
                    /> : formData.Obct14}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Phm15"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Phm15"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Phm15}
                    /> : formData.Phm15}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Phf16"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Phf16"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Phf16}
                    /> : formData.Phf16}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Pht17"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Pht17"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Pht17}
                    /> : formData.Pht17}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="MinorityCommunityM18"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="MinorityCommunityM18"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.MinorityCommunityM18}
                    /> : formData.MinorityCommunityM18}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="MinorityCommunityF19"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="MinorityCommunityF19"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.MinorityCommunityF19}
                    /> : formData.MinorityCommunityF19}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="MinorityCommunityT20"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="MinorityCommunityT20"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.MinorityCommunityT20}
                    /> : formData.MinorityCommunityT20}
                </td>
            </tr>
    );
};

export default ES27RevisedUpdate;
